import React, { useState } from 'react';
import PostcodeSearch from './PostcodeSearch';
import LitImage from './images/LitImage';
import { graphql, useStaticQuery } from 'gatsby';
const BottomPostcodeSection = ({
  heading,
  content,
  index,
  arrowsLeft,
  arrowsRight,
  backgroundColor,
}) => {
  const [selectedAddress, setSelectedAddress] = useState(undefined);
  const [inputDisplayValue, setInputDisplayValue] = useState('');

  const data = imageQuery();

  return (
    <div id="bottomPostcode" key={index} className={`${backgroundColor}`}>
      <div className="bottom-postcode-container modular-padding-large">
        <div className="bottom-postcode-content">
          <div
            className={` ${
              !content
                ? 'bottom-postcode-arrow-height'
                : 'bottom-postcode-arrow'
            }`}
          >
            <LitImage
              image={arrowsLeft ? arrowsLeft : data.arrowsLeft}
              alt="arrows pointing right"
            />
          </div>
          <div className="bottom-postcode-inner">
            {heading && <h4>{heading}</h4>}
            {content && <p className="bottom-postcode-content">{content}</p>}
            <div className="PostcodeSearchPrimary">
              <PostcodeSearch
                placeholder="Check availability"
                selectedAddress={selectedAddress}
                setSelectedAddress={setSelectedAddress}
                inputDisplayValue={inputDisplayValue}
                setInputDisplayValue={setInputDisplayValue}
              />
            </div>
          </div>{' '}
          <div
            className={` ${
              !content
                ? 'bottom-postcode-arrow-height'
                : 'bottom-postcode-arrow'
            }`}
          >
            <LitImage
              image={arrowsRight ? arrowsRight : data.arrowsRight}
              alt="arrows pointing left"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomPostcodeSection;
const imageQuery = () =>
  useStaticQuery(graphql`
    {
      arrowsLeft: file(relativePath: { eq: "audience-images/arrowsLeft.png" }) {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
        extension
        publicURL
      }
      arrowsRight: file(
        relativePath: { eq: "audience-images/arrowsRight.png" }
      ) {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
        extension
        publicURL
      }
    }
  `);
